export const ToyStory = () => {
    let datas = require.context('../../assets/images/origins/toy-story', false);
    return datas.keys().map(image => datas(image));
}